const filterAndReduceAmountByMonthOnly = (voucherDetailsList, targetMonth) => {
    // Get the current year
    const currentYear = new Date().getFullYear();

    // Filter vouchers for the target month and current year
    const filteredVouchers = voucherDetailsList.filter(voucher => {
        const voucherDate = new Date(voucher.voucherPurchaseDate);
        const voucherMonth = voucherDate.getMonth() + 1; // +1 because getMonth() returns zero-based index
        const voucherYear = voucherDate.getFullYear();
        return voucherMonth === targetMonth && voucherYear === currentYear;
    });

    // Reduce the amount of filtered vouchers
    const reducedAmount = filteredVouchers.reduce((total, voucher) => {
        return total + voucher.voucherAmount;
    }, 0);

    // Return both filtered vouchers and reduced amount
    return { filteredVouchers, reducedAmount };
}

export default filterAndReduceAmountByMonthOnly;
